var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-outlined",class:_vm.loading || _vm.fbLoading ? 'is-loading': '',attrs:{"type":"button"},on:{"click":_vm.connectFacebook}},[_vm._m(0),_vm._v("  "),_c('span',[_vm._v(_vm._s(_vm.$t('signin.actions.facebook')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon has-text-facebook"},[_c('i',{staticClass:"mdi mdi-facebook"})])
}]

export { render, staticRenderFns }